
export class ExternalReq {
    externalRef?: string;
    createdAt?: any;

    constructor(externalRef: string,createdAt?:any) {
        this.externalRef = externalRef
        this.createdAt = createdAt
    }
}


export class AddressReq {
    buyerName?: string;
    country?: string;


    constructor( buyerName?: string,
        country?: string) {
        this.buyerName = buyerName
        this.country = country
    }
}
